export default class Position {
  public constructor(
    public readonly x: number,
    public readonly y: number,
    public readonly z: number
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Position.ts